module.exports = __webpack_public_path__ + "img/googlePlay.61a54eeb.png";